import { FormControl, Select, InputLabel, MenuItem } from '@material-ui/core'
import './ListSelect.css'
import { stripDuplicates } from '../../utils/DataUtils'

const ListSelect = ({ options, label, selectedValue, onChange, hideAll }) => {
  const uniqueOptions = stripDuplicates(options, 'value')

  return (
    <div className="listSelectContainer">
      <FormControl style={{ minWidth: '190px' }} variant="outlined">
        <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
        <Select
          label={label}
          onChange={(e) => onChange(e.target.value)}
          value={selectedValue}
        >
          {!hideAll && (
            <MenuItem key={0} value={0}>
              All
            </MenuItem>
          )}
          {uniqueOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.displayText}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default ListSelect
